module.exports = __webpack_public_path__ + "img/404-not-found.ced46e8.png";